import React from "react";
import TransactionsList from "../components/transactions/TransactionsList";

const TransactionsPage: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8 mt-14">
      <TransactionsList />
    </div>
  );
};

export default TransactionsPage;
